<section class="main-section" *ngIf="carriersList">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Carriers</li>
    </ol>
  </nav>

  <div class="row">
    <div class="col">
      <div class="inner-box connect-bg2 pb-4">
        <div class="row">
          <div class="col-md-3">
            <h1 class="f-32 text-orange fw-500">Create Your Carriers</h1>
            <button class="btn btn-orange-prime mt-4" routerLink="/admin/adminCarriersList/">Create now</button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row mt-4">
    <div class="col">
      <div class="inner-box d-none d-sm-block">
        <h2 class="color-3 text-capitalize mt-3 mb-4">My Carriers</h2>
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a (click)="populateTabData('active');getCarriersList('ACTIVE');  tabChange();"  [ngClass]="{'active': tabClicked === 'active'}">Active</a></li>
          <li class="list-inline-item"><a (click)="populateTabData('inactive');getCarriersList('IN_ACTIVE'); tabChange();" [ngClass]="{'active': tabClicked === 'inactive'}">Inactive</a></li>
        </ul>
        <div class="table-3">
          <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
            <thead class="thead-light">
            <tr>
              <th></th>
              <th>Carrier Name</th>
              <th>Last Sync Time</th>
              <th>Status</th>
              <th [hidden]="tabClicked === 'inactive'" width="200">Action</th>
              <th [hidden]="tabClicked === 'active'">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor = "let s of carriersList;let i = index;">
              <td><img src="assets/images/1-{{s.carrierCode}}.png"></td>
              <td>{{s.connectionName}}</td>
              <td>{{s.orderUpdatedDate || 'Never Synced'}} </td>
              <td>
                <div class="d-inline custom-control custom-switch">
                  <input type="checkbox"  class="custom-control-input float-right" (change)="updateStatus(s,i)" [checked]="s.status==='ACTIVE'"id="statusMagento-{{s.carrierId}}">
                  <label class="custom-control-label" for="statusMagento-{{s.carrierId}}"> </label>
                </div>
              </td>

              <td [hidden]="tabClicked === 'inactive'">
                <button type="submit" (click)="testConnection(s)" class="btn btn-blue">Test</button>
                <button class="btn btn-green2 ml-3" (click)="getCarriersManage(s,s.carrierCode)">Manage</button>
              </td>

              <td [hidden]="tabClicked === 'active'"><a data-toggle="modal" data-target="#deleteApiPop" (click)="deleteCarrier(s)"
                                                        class="p-2 ml-3">
                <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                  <defs><style>.a{fill:#848484;}</style></defs>
                  <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                </svg>
              </a> </td>
            </tr>

            </tbody>
            <tfoot>
            <tr *ngIf="!carriersList?.length || carriersList?.length===0">
              <td colspan="6" align="center">No carrier data available</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>


      <div class="inner-box d-block d-sm-none">
        <h2 class="color-3 text-capitalize mt-3 mb-4">My Carriers</h2>
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a (click)="populateTabData('active');getCarriersList('ACTIVE');  tabChange();"  [ngClass]="{'active': tabClicked === 'active'}">Active</a></li>
          <li class="list-inline-item"><a (click)="populateTabData('inactive');getCarriersList('IN_ACTIVE'); tabChange();" [ngClass]="{'active': tabClicked === 'inactive'}">Inactive</a></li>
        </ul>
        <div class="table-3">
          <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack" >
            <thead class="thead-light">
            <tr>
              <th></th>
              <th>Channel Name</th>
              <th>Last Sync Time</th>
              <th>Status</th>
              <th [hidden]="tabClicked === 'inactive'" width="200">Action</th>
              <th [hidden]="tabClicked === 'active'">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor = "let s of carriersList;let i = index;">
              <td><img src="assets/images/1-{{s.carrierCode}}.png"></td>
              <td><b class=" tablesaw-cell-label">Channel Name</b>
                <span class="tablesaw-cell-content">{{s.connectionName}}</span></td>
              <td><b class=" tablesaw-cell-label">Last Sync Time</b>
                <span class="tablesaw-cell-content">{{s.orderUpdatedDate || 'Never Synced'}} </span></td>
              <td>
                <b class=" tablesaw-cell-label">Status</b>
                <span class="tablesaw-cell-content">
                 <div class="d-inline custom-control custom-switch">
                    <input type="checkbox"  class="custom-control-input float-right" (change)="updateStatus(s,i)" [checked]="s.status==='ACTIVE'"id="statusMagento-{{s.carrierId}}">
                    <label class="custom-control-label" for="statusMagento-{{s.carrierId}}"> </label>
                  </div>
             </span>
              </td>
              <td [hidden]="tabClicked === 'inactive'">
                <b class=" tablesaw-cell-label">Actions</b>
                <span class="tablesaw-cell-content">
                        <button type="submit" (click)="testConnection(s)" class="btn btn-blue">Test</button>
                        <button class="btn btn-green2 ml-3" (click)="getCarriersManage(s,s.carrierCode)">Manage</button>
                        </span></td>
              <td [hidden]="tabClicked === 'active'">
                <a data-toggle="modal" data-target="#deleteApiPop" (click)="deleteCarrier(s)"
                   class="p-2 ml-3">
                  <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                    <defs><style>.a{fill:#848484;}</style></defs>
                    <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                  </svg>
                </a> </td>
            </tr>

            </tbody>
            <tfoot>
            <tr *ngIf="!carriersList?.length || carriersList?.length===0">
              <td colspan="6" align="center">No channel data available</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="container">
  <div class="modal fade" id="deleteApiPop" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Do you really want to delete </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal" (click)="closePopup()">No</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="modifyStatus()">Yes</button>
        </div>
      </div>
    </div>
  </div>
</div>
